const React = require('react');

const names = (items) => items.map((item) => item.name || item.id).join(', ') || 'None';

module.exports = function MatchingDebugPanel({ debug }) {

    if (!debug) {
        return null;
    }

    return <details open style={{ margin: '16px 0' }}>
        <summary><strong>Match debugging</strong></summary>
        <dl>
            {typeof debug.scoreTotal !== 'undefined' && <><dt>Total score</dt><dd>{debug.scoreTotal}</dd></>}
            {debug.exactInterests && <><dt>Exact interests</dt><dd>{names(debug.exactInterests)}</dd></>}
            {debug.exactPassions && <><dt>Exact passions</dt><dd>{names(debug.exactPassions)}</dd></>}
            {debug.sharedGroups && <><dt>Shared groups</dt><dd>{names(debug.sharedGroups)}</dd></>}
            {debug.relatedMatches && <><dt>Related matches</dt><dd>{debug.relatedMatches.join(' ') || 'None'}</dd></>}
            {debug.scoreDetails && Object.entries(debug.scoreDetails).map(([key, value]) => <React.Fragment key={key}><dt>{key}</dt><dd>{value}</dd></React.Fragment>)}
        </dl>
        <p><small>{debug.note}</small></p>
    </details>;
};
